// src/components/SkeletonLoader/SkeletonLoader.tsx
import React, { CSSProperties } from 'react';
import styles from './SkeletonLoader.module.css';

interface SkProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  style?: CSSProperties;
  className?: string;
}

const toCSS = (v: string | number | undefined) =>
  v === undefined ? undefined : typeof v === 'number' ? `${v}px` : v;

export const SkBox: React.FC<SkProps> = ({ width, height, borderRadius, style, className }) => (
  <span
    className={`${styles.skBox} ${className || ''}`}
    style={{ width: toCSS(width), height: toCSS(height), borderRadius: toCSS(borderRadius), ...style }}
  />
);

export const SkText: React.FC<SkProps> = ({ width, height = 14, borderRadius, style, className }) => (
  <span
    className={`${styles.skText} ${className || ''}`}
    style={{ width: toCSS(width), height: toCSS(height), borderRadius: toCSS(borderRadius), ...style }}
  />
);

export const SkCircle: React.FC<SkProps> = ({ width = 36, height, style, className }) => (
  <span
    className={`${styles.skCircle} ${className || ''}`}
    style={{ width: toCSS(width), height: toCSS(height ?? width), ...style }}
  />
);
